export default interface CompanyForm {
    id: number;
    name: string;
}

export const companyFormDefaultProps: CompanyForm = {
    id: 0,
    name: ''
}
